import React from 'react';

type LandingButtonVariant = 'default' | 'secondary' | 'ghost' | 'outline' | 'gradient';
type LandingButtonSize = 'default' | 'sm' | 'lg';

interface LandingButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: LandingButtonVariant;
  size?: LandingButtonSize;
}

const BASE_STYLES =
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50';

const VARIANTS: Record<LandingButtonVariant, string> = {
  default: 'bg-black text-white hover:bg-gray-800',
  secondary: 'bg-gray-100 text-black hover:bg-gray-200',
  ghost: 'hover:bg-gray-100 text-black',
  outline: 'border border-gray-300 bg-white text-black hover:bg-gray-50',
  gradient:
    'bg-gradient-to-b from-black via-black/95 to-black/80 text-white hover:scale-105 active:scale-95 shadow-lg shadow-black/20',
};

const SIZES: Record<LandingButtonSize, string> = {
  default: 'h-10 px-4 py-2 text-sm',
  sm: 'h-10 px-5 text-sm',
  lg: 'h-12 px-8 text-base',
};

export const LandingButton = React.forwardRef<HTMLButtonElement, LandingButtonProps>(
  ({ variant = 'default', size = 'default', className = '', children, ...props }, ref) => (
    <button
      ref={ref}
      className={`${BASE_STYLES} ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  ),
);
LandingButton.displayName = 'LandingButton';
